module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDYzOS45OHY0NzkuOTk4SDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMzZhMTAwIiBkPSJNNDI2LjY1NCAwSDYzOS45OHY0NzkuOTk4SDQyNi42NTR6TTAgMGgyMTMuMzI3djQ3OS45OThIMHoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ng.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ng.svg
// module chunks = 0